import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';
import { FeesSection } from 'src/app/cd-request/models/closing-disclosure-doc-request.model';

export interface DocOrderFeesFormData {
  applicationFee: number | null;
  loanOriginationFee: number | null;
  discountPointFee: number | null;
  underwriterFee: number | null;
  processorFee: number | null;
  inHouseProcessingFee: number | null;
  thirdPartyProcessingFee: number | null;
  appraisalFee: number | null;
  creditReportFee: number | null;
  surveyFee: number | null;
  borrowerPaidCompensation: number | null;
  lenderPaidCompensation: number | null;
  originationCredit: number | null;
  txAttorneyFee: number | null;
}

@Component({
  selector: 'doc-order-fees',
  templateUrl: './doc-order-fees.component.html',
  styleUrls: ['./doc-order-fees.component.scss'],
  standalone: false
})
export class DocOrderFeesComponent extends ApplicationContextBoundComponent implements OnInit, OnChanges {

  @ViewChild('docOrderFeesForm') docOrderFeesForm: NgForm;

  @Input() fees: FeesSection | undefined;

  formData: DocOrderFeesFormData = {
    applicationFee: null,
    loanOriginationFee: null,
    discountPointFee: null,
    underwriterFee: null,
    processorFee: null,
    inHouseProcessingFee: null,
    thirdPartyProcessingFee: null,
    appraisalFee: null,
    creditReportFee: null,
    surveyFee: null,
    borrowerPaidCompensation: null,
    lenderPaidCompensation: null,
    originationCredit: null,
    txAttorneyFee: null
  };

  isLoading: boolean = false;

  constructor(
    protected readonly injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fees']) {
      this.populateFormFromApiData();
    }
  }

  validateForm(): boolean {
    if (this.docOrderFeesForm) {
      this.docOrderFeesForm.form.markAllAsTouched();
      return this.docOrderFeesForm.form.valid;
    }
    return true;
  }

  getFormData(): DocOrderFeesFormData {
    return { ...this.formData };
  }

  private populateFormFromApiData(): void {
    if (!this.fees) {
      return;
    }

    this.formData.applicationFee = this.fees.applicationFee ?? null;
    this.formData.loanOriginationFee = this.fees.loanOriginationFee ?? null;
    this.formData.discountPointFee = this.fees.discountPointFee ?? null;
    this.formData.underwriterFee = this.fees.underwriterFee ?? null;
    this.formData.processorFee = this.fees.processorFee ?? null;
    this.formData.inHouseProcessingFee = this.fees.inHouseProcessingFee ?? null;
    this.formData.thirdPartyProcessingFee = this.fees.thirdPartyProcessingFee ?? null;
    this.formData.appraisalFee = this.fees.appraisalFee ?? null;
    this.formData.creditReportFee = this.fees.creditReportFee ?? null;
    this.formData.surveyFee = this.fees.surveyFee ?? null;
    this.formData.borrowerPaidCompensation = this.fees.borrowerPaidCompensation ?? null;
    this.formData.lenderPaidCompensation = this.fees.lenderPaidCompensation ?? null;
    this.formData.originationCredit = this.fees.originationCredit ?? null;
    this.formData.txAttorneyFee = this.fees.txAttorneyFee ?? null;
  }
}
